import {useDebugValue} from 'react';

import {undef, runHPPrePopulateCookieExperiment} from '../../../utils';

import {useValues} from './';

const defaultDestinationValues = {
    destination: null,
    destinationUuid: undef,
    subDestination: null,
    listingProps: null
};

function useDestinationValues(props, searchCookies, systemOptions, abacusStore) {
    const {
        destinationValues: propsDestinationValues
    } = props;

    let {
        destinationValues: cookiesDestinationValues
    } = searchCookies;

    cookiesDestinationValues = runHPPrePopulateCookieExperiment(abacusStore, systemOptions, searchCookies) ? {} : cookiesDestinationValues;

    const {
        initialValues: initialDestinationValues,
        currentValues: currentDestinationValues,
        latestValues: latestDestinationValues,
        setCurrentValues: setCurrentDestinationValues,
        setCurrentValuesDefault: setCurrentDestinationValuesDefault,
        setCurrentValuesInitial: setCurrentDestinationValuesInitial,
        setCurrentValuesLatest: setCurrentDestinationValuesLatest,
        setLatestValues: setLatestDestinationValues,
        setLatestValuesDefault: setLatestDestinationValuesDefault,
        setLatestValuesInitial: setLatestDestinationValuesInitial,
        setLatestValuesCurrent: setLatestDestinationValuesCurrent,
        setAllValues: setAllDestinationValues,
        setAllValuesDefault: setAllDestinationValuesDefault,
        setAllValuesInitial: setAllDestinationValuesInitial
    } = useValues(defaultDestinationValues, cookiesDestinationValues, propsDestinationValues);

    const result = {
        defaultDestinationValues,
        initialDestinationValues,
        currentDestinationValues,
        latestDestinationValues,
        setCurrentDestinationValues,
        setCurrentDestinationValuesDefault,
        setCurrentDestinationValuesInitial,
        setCurrentDestinationValuesLatest,
        setLatestDestinationValues,
        setLatestDestinationValuesDefault,
        setLatestDestinationValuesInitial,
        setLatestDestinationValuesCurrent,
        setAllDestinationValues,
        setAllDestinationValuesDefault,
        setAllDestinationValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useDestinationValues};
